import React from 'react';
import img1 from '../../assets/images/totalemployees-icon.svg';
import img2 from '../../assets/images/information-icon.svg';
import img3 from '../../assets/images/documents-icon.svg';
import img4 from '../../assets/images/user1.png';
import img5 from '../../assets/images/user2.png';
import img6 from '../../assets/images/user3.png';
import img7 from '../../assets/images/users/1.jpg';

import { Link } from 'react-router-dom';
import { CardBody, Card, Row, Col, Pagination,
    PaginationItem, PaginationLink, UncontrolledPopover,
    PopoverBody, Container, Table} from 'reactstrap';
    
const Overview = () => {
    return (
        <Container>
        <Row className="hr-overview">
             <Col xs="12" md="12" sm="12">
                <Row>
                    <Col><Card  style={{ height:'230px'}}>
                    <CardBody >
                    <h4 style={{fontStyle: 'normal',
                    fontWeight:'600',
                    fontSize: '15.01px',
                    lineHeight:'12px', color: '#121127'}} className="text-nowrap">Total Employees</h4>
                    <p style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'16px', color: '#121127'}} className="text-nowrap">Added to Hessab</p>
                    <div style={{position:'absolute', bottom:'20px'}}>
                    <div className='d-flex' ><img src={img1} alt="user"  width="40" /> <span style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '40px',
                    lineHeight:'60px', color: '#121127'}}>17</span></div>
                    <span style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'18px', color: '#6F6F7B'}} >14 Employes - 3 Dependents</span>
                    <Link  to="/v2/employeesComponents" className="text-nowrap" style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '10px',
                    lineHeight:'15px', color: '#72B566',textDecorationLine: 'underline', display:'block', marginTop:'5px'}}>Go to Employees <i className="fa fa-angle-right" aria-hidden="true" style={{fontSize:'15px',
                    paddingLeft:'6px', position: 'relative', top:'3px'
                    }}></i>
                    </Link>
                    </div>
                    </CardBody>
                    </Card></Col> 
                    <Col><Card  style={{ height:'230px'}}>
                    <CardBody>
                    <h4 style={{fontStyle: 'normal',
                    fontWeight:'600',
                    fontSize: '15.01px',
                    lineHeight:'12px', color: '#121127'}} >Missing Information</h4>
                    <p style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'16px', color: '#121127'}} >Employees missing important
                    information</p>

                    <div style={{position:'absolute', bottom:'20px'}}>

                    <div className='d-flex'  ><img src={img2} alt="user" width="40"/> <span style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '40px',
                    lineHeight:'60px', color: '#121127'}}>12</span></div>
                    <span style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'18px', color: '#6F6F7B'}}>Employes Missing Documents</span>
                    <Link to="#" className="text-nowrap" style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '10px',
                    lineHeight:'15px', color: '#72B566',textDecorationLine: 'underline', display:'block', marginTop:'5px'}}>Find out who<i className="fa fa-angle-right" aria-hidden="true" style={{fontSize:'15px',
                    paddingLeft:'6px', position: 'relative', top:'3px'
                    }}></i>
                    </Link>
                    </div>
                    </CardBody>
                    </Card></Col> 
                    <Col><Card  style={{ height:'230px'}}>
                    <CardBody>
                    <h4 style={{fontStyle: 'normal',
                    fontWeight:'600',
                    fontSize: '15.01px',
                    lineHeight:'12px', color: '#121127'}} className="text-nowrap">Missing Documents</h4>
                    <p style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'16px', color: '#121127'}} >Employees missing required 
                    documents</p>
                    <div style={{position:'absolute', bottom:'20px'}}>
                    <div className='d-flex'  ><img src={img3} alt="user"  width="40" />   <span style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '40px',
                    lineHeight:'60px', color: '#121127'}}> 12</span></div> 
                    <span style={{fontStyle: 'normal',
                    fontWeight:'400',
                    fontSize: '12px',
                    lineHeight:'18px', color: '#6F6F7B'}}>14 Employes -3 Dependents</span>
                    <Link to="#" className="text-nowrap"style={{fontStyle: 'normal',
                    fontWeight:'700',
                    fontSize: '10px',
                    lineHeight:'15px', color: '#72B566',textDecorationLine: 'underline', display:'block', marginTop:'5px'}}>Find  out who<i className="fa fa-angle-right" aria-hidden="true" style={{fontSize:'15px',
                    paddingLeft:'6px', position: 'relative', top:'3px'
                    }}></i>
                    </Link>
                    </div>
                    </CardBody>
                    </Card></Col>
                    <Col><Card style={{width:'auto',height:'230px'}}>
                    <CardBody>
                    <i id="PopoverLegacy9" type="button" className="fa fa-ellipsis-h float-right" style={{backgroundColor:'#72B566',color:'#fff', padding:'5px', borderRadius:'5px'}}/>
                    <UncontrolledPopover
                    trigger="legacy"
                    placement="bottom"
                    target="PopoverLegacy9"
                    >
                    <PopoverBody>
                        <span style={{color:'#72B566', display:'block'}}>Send invite</span>
                        <span style={{color:'#72B566', display:'block'}}>Reset password</span>
                        <span style={{color:'#72B566', display:'block'}}> Change role</span>
                    </PopoverBody>
                    </UncontrolledPopover>
                    <h4 style={{fontStyle: 'normal',
                    fontWeight:'600',
                    fontSize: '15.01px',
                    lineHeight:'12px', color: '#121127'}}>Holiday/Absent</h4>
                    <div className="d-flex justify-content-center align-items-center " style={{marginTop:'29px'}}> 
                         <div className='d-flex float-left'>
                           <img src={img4} alt="user"  width="29" /> 
                            <span className='text-nowrap' style={{ padding:'5px 25px 0px 5px', fontSize:'12px'}}>Alaa Laamriri<br/><br/><span style={{color:'#72b566'}}>Travel disruption</span></span>
                        </div>
                        <div className="d-flex">
                           <span className='text-nowrap float-right' style={{ paddingLeft:'6px', fontSize:'12px'}}>16th-18th<br/><br/>May 2021</span>
                        </div>
                    </div>
                    <hr/>
                    <div className="d-flex justify-content-center align-items-center ">
                         <div className='d-flex float-left'>
                           <img src={img5} alt="user"  width="29" /> 
                            <span className='text-nowrap' style={{ padding:'5px 25px 0px 5px', fontSize:'12px'}}>Alaa Laamriri<br/><br/><span style={{color:'#72b566'}}>Travel disruption</span></span>
                        </div>
                        <div className="d-flex">
                           <span className='text-nowrap float-right' style={{ paddingLeft:'6px', fontSize:'12px'}}>16th-18th<br/><br/>May 2021</span>
                        </div>
                    </div>
                    <hr/>
                    <div className="d-flex justify-content-center align-items-center ">
                         <div className='d-flex float-left'>
                           <img src={img6} alt="user"  width="29" /> 
                            <span className='text-nowrap' style={{ padding:'5px 25px 0px 5px', fontSize:'12px'}}>Alaa Laamriri<br/><br/><span style={{color:'#72b566'}}>Travel disruption</span></span>
                        </div>
                        <div className="d-flex">
                           <span className='text-nowrap float-right' style={{ paddingLeft:'6px', fontSize:'12px'}}>16th-18th<br/><br/>May 2021</span>
                        </div>
                    </div>
                    </CardBody>
                    </Card></Col>  
                 </Row>
                 <Card>
                    <CardBody>

                    <h4 style={{fontWeight: '600',fontSize:'15.01px', lineHeight: '23px'}} className='float-left'>Employes Summery </h4>
                    <Link className='float-right' style={{fontSize:'14px',
lineHeight:'21px',
textDecorationLine:'underline',
color:'#72B566'}} to="/v2/employeesComponents">View All</Link>
                    <Table className="no-wrap v-middle text-center" responsive center>
                    <thead>
                        <tr className="border-0">
                            <th className="border-0">Employee Name</th>
                            <th className="border-0">Id</th>
                            <th className="border-0">Department</th>
                            <th className="border-0">Hire Date</th>
                            <th className="border-0">Profile Completion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border-0">
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img5} alt="user" className="rounded-circle" width="35" /></div>
                                        Ibrahim el tayer
                                </div>
                            </td>
                            <td className="border-0">FT-007</td>
                            <td className="border-0">Marketing</td>

                            <td className="border-0">
                                11/01/2022
                            </td>
                            <td className="border-0" style={{color:'#72B566'}}>90%</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img4} alt="user" className="rounded-circle" width="35" /></div>
                                        Ahssan el tayer
                                </div>
                            </td>
                            <td>FT-007</td>
                            <td>Marketing</td>
                            <td>
                                11/01/2022

                            </td>
                            <td style={{color:'#EB6766'}}>40%</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img6} alt="user" className="rounded-circle" width="35" /></div>
                                        Ahssan el tayer
                                </div>
                            </td>
                            <td>FT-007</td>
                            <td>Finance</td>
                            <td>
                                11/01/2022

                            </td>
                            <td style={{color:'#72B566'}}>90%</td>
                           
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img7} alt="user" className="rounded-circle" width="35" /></div>
                                        Ahssan el tayer
                                 </div>
                            </td>
                            <td  >FT-007</td>
                            <td>It</td>
                            <td>
                                11/01/2022
                            </td>
                            <td style={{color:'#72B566'}}>90%</td>
                         
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img6} alt="user" className="rounded-circle" width="35" /></div>
                                        Patrick silva
                                </div>
                            </td>
                            <td>FT-007</td>
                            <td>Marketing</td>
                            <td>
                                11/01/2022

                            </td>
                            <td style={{color:'#EB6766'}}>55%</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex no-block align-items-center">
                                    <div className="mr-2"><img src={img4} alt="user" className="rounded-circle" width="35" /></div>
                                        Jan Petrovic
                                </div>
                            </td>
                            <td>FT-007</td>
                            <td>Marketing</td>
                            <td>
                            11/01/2022
                                
                            </td>
                            <td style={{color:'#72B566'}}>90%</td>
                        </tr>
                    </tbody>

                </Table>
                <Pagination aria-label="Page navigation example" className='float-left'>
  <PaginationItem disabled>
    <PaginationLink
      first
      href="#"
    />
  </PaginationItem>
  <PaginationItem disabled>
    <PaginationLink
      href="#"
      previous
    />
  </PaginationItem>
  <PaginationItem active>
    <PaginationLink href="#">
      1
    </PaginationLink>
  </PaginationItem>
  
  
  <PaginationItem>
    <PaginationLink
      href="#"
      next
    />
  </PaginationItem>
  <PaginationItem>
    <PaginationLink
      href="#"
      last
    />
  </PaginationItem>
</Pagination>
                    

                                

                    </CardBody>
                    </Card>   
                   



            </Col>
         </Row>
        </Container>
    );
}
export default Overview;
